
export const NO_RECORD_FOUND: string = "NoRecordFound";